


















































import Vue from 'vue'
import { mapState } from 'vuex'
import store from '@/store'
export default Vue.extend({
    name: 'AppBar',
    components: {
        Login: () => import('@/components/Login/Login.vue'),
        SendPasswordReset: () => import('@/components/Login/SendPasswordReset.vue'),
    },
    data() {
        return {
            langs: ['zh-CN', 'en', 'de'],
            // loginOpen: false,
        }
    },
    computed: {
        ...mapState('user', ['user']),
        loginOpen() {
            return this.$route.hash === '#login'
        },
        passwordResetOpen() {
            return this.$route.hash === '#send-password-reset'
        },
    },
    methods: {
        logout() {
            store.dispatch('user/logout')
            this.$router.go(0)
        },
        openDialog(hashRoute: string) {
            this.$router.replace(this.$route.path + `#${hashRoute}`)
        },
        closeDialog() {
            this.$router.replace(this.$route.path)
            this.$router.go(0)
        },
        gotoPath(pathname: string) {
            if (this.$route.name !== pathname) {
                this.$router.push({ name: pathname })
            }
        },
    },
})
